import DocumentList from '../../Component/reusable_components/documents_list.js'
import { IMAGE_BASE_PATH_DBRALC } from '../../Config/Config'
import NepIksIdpData from '../../Assets/JSON/Aboutjson/NepIksIdp.json'

const DistinctiveFeature = () => {
  return (
    <DocumentList
      data={NepIksIdpData}
      title="NEP, IKS & IDP"
      basePath={IMAGE_BASE_PATH_DBRALC}
      navigatePath="/nepiksidppage"
    />
  )
}
export default DistinctiveFeature
